<template>
    <div class="modal modal-category fade in show" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" >
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span>&times;</span>
                </button>
                <div class="modal-inner">
                    <h5 class="title">{{ titleText }}</h5>
                    <div class="form">
                        <form action="">
                            <label class="form-group">
                                <span class="form-label">Title Subcategory</span>
                                <input
                                    type="text"
                                    v-model="inputValue"
                                    class="form-control pl-4"
                                >
                            </label>
                            <div class="buttons">
                                <button @click.prevent="closeForm" class="btn btn_primary-outline pl-5 pr-5">Cancel</button>
                                <button @click.prevent="saveForm" class="btn btn_golden"><span
                                    class="pl-5 pr-5">Save</span></button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: "CategoryModal",
    props: {
        mainSubcat:{
           type: Object
        },
        modalId: {
            type: String,
            required: true,
        },
        titleText: String,
        propsValue: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['create', 'update'],
    data() {
        return {
            inputValue: null
        }
    },
    methods: {
        validate() {
            if (!this.inputValue || this.inputValue.toString().trim() === "") {
                this.$showErrorMessage('Title is not valid or empty')
            } else {
                this.saveForm()
            }
        },
        closeForm() {
            $(`#${this.modalId}`).modal('hide');
            this.inputValue = ''
        },
        saveForm() {
            if (this.propsValue.index !== 'new') {
                this.$emit('update', { index: this.propsValue.index, name: this.inputValue,  });
            } else {
                this.$emit('create', { name: this.inputValue, id: null });
            }
            this.closeForm()
        }
    }
})
</script>


<style scoped>

</style>
